/**
 * Initializes an Alpine.js data object to enhance cursor interactions with smooth, animated movement.
 * Key features include:
 * 1. Dynamic Movement: Updates cursor position in real-time as the user moves the mouse.
 * 2. Activation State: Toggles a custom 'active' class on cursor hover for visual feedback.
 * 3. Performance Optimization: Utilizes animation frames for efficient cursor tracking and updates.
 */

function playCursor() {
  let animationFrameId = null;
  return {
    cursorPosition: {
      x: null,
      y: null
    },
    hovered: false,

    enter() {
      this.hovered = true;
      this.$refs.cursor.classList.add('active');
      this.startAnimating();
    },

    move(event) {
      this.cursorPosition.x = event.clientX;
      this.cursorPosition.y = event.clientY;
      if (!this.hovered) {
        this.enter();
      }
    },

    leave() {
      this.hovered = false;
      this.$refs.cursor.classList.remove('active');
      this.cursorPosition = {
        x: null,
        y: null
      };
      cancelAnimationFrame(animationFrameId);
    },

    updateCursor() {
      if (this.cursorPosition.x !== null && this.cursorPosition.y !== null) {
        this.$refs.cursor.style.left = `${this.cursorPosition.x}px`;
        this.$refs.cursor.style.top = `${this.cursorPosition.y}px`;
      }
    },

    startAnimating() {
      const animate = () => {
        if (!this.hovered) return;
        this.updateCursor();
        animationFrameId = requestAnimationFrame(animate);
      };
      animate();
    }
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('playCursor', playCursor);
});
